/**
 * Bot pacing for local games: readable, slightly human. Base ~0.9s with
 * jitter (0.7-1.1s), a little longer before swapping into a face-down slot,
 * quicker during the simultaneous tee off, and a short breath after the
 * human's own move. `speed` scales everything (?speed=0.2 for testing).
 */
import type { Action, GameState } from '../../engine';

export interface PaceInput {
  action: Action;
  state: GameState;
  /** The previous move was the human's. */
  afterHuman: boolean;
  speed: number;
  /** 0..1 random source. */
  rand: () => number;
}

export const PACE = {
  min: 700,
  max: 1100,
  teeOffMin: 350,
  teeOffMax: 900,
  hiddenSwapExtra: 150,
  afterHuman: 350,
};

export function botDelay({ action, state, afterHuman, speed, rand }: PaceInput): number {
  let ms: number;
  if (action.type === 'flipInitial') {
    ms = PACE.teeOffMin + rand() * (PACE.teeOffMax - PACE.teeOffMin);
  } else {
    ms = PACE.min + rand() * (PACE.max - PACE.min - PACE.hiddenSwapExtra);
    if (action.type === 'swap') {
      const slot = state.players[action.player]?.grid[action.slot];
      if (slot && !slot.faceUp) ms += PACE.hiddenSwapExtra;
    }
    if (afterHuman) ms += PACE.afterHuman;
  }
  return Math.round(ms * speed);
}
